module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABSUlEQVR42u3WvUoEMRAHcBsLGxux8gOEa8/OxjfKZDeTmSx3bndgo4IIYrMIWomNle8h2GilpzYigh9voBNhbrG65pJqB4Yl2eKX/zIsmctRgGHLeK4BqWiaZj4P6gIapBfwvG8c3xpHP+VotJgUNch74Hhs63qp3QuXgHyeNCk4ereOD//tM28D0k1ClMdA1BPkHjyPJokdnxrki5mj1rM3SE/AvBbXZV0vC3YXccBAgn7ogM0UjUnLwWB1stnir/FAiMP15KiW8aE0XiabdnpZUU3aoR3aoVNRi+zk3XN2VH+RHdqh09Cj7GhRVRvxMmaRdnOhejm7so6PjeMHQApZ0IKoL9gbES1IryguXSRDNa3xzLoWvC/gl/SjoknT/t2PMBxI4k95numQJUsrPVRQ+iR+7mSgpo2TLPB3FrBNW22Co2sFc9UvvCtI+87sL/IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-edit_2x.png
// module id = 953
// module chunks = 0